import Manager from 'coreClasses/Manager';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents EnvVariablesMgr
 */
class EnvPreferencesMgr extends Manager {
	private envPreferences: object;

	/**
	 * Constructor for EnvPreferencesMgr
	 * @param {ManagerRepository} managerRepository - The manager repository instance.
	 * @param {object} envPreferences - The environment preferences object.
	 */
	constructor(managerRepository: ManagerRepository, envPreferences: object) {
		super(managerRepository);

		this.envPreferences = envPreferences;
	}

	/**
	 * Get a specific environment preference by key
	 * @param {string} key - The key of the environment preference.
	 * @returns {any} The value of the environment preference.
	 */
	get(key: string): any {
		if (this.envPreferences?.hasOwnProperty(key)) {
			return this.envPreferences[key];
		}

		return undefined;
	}
}

export default EnvPreferencesMgr;
